<app-modal
  [open]="open()"
  [title]="'SIGN_LEGAL_DOCUMENT_MODAL_TITLE'"
  [showCancel]="false"
  [showCloseIcon]="false"
  [disableBackdropClose]="true"
  confirmLabel="SIGN_LEGAL_DOCUMENT"
  [confirmLoading]="loading()"
  (confirmed)="confirmed.emit()"
>
  @if (documentType()) {
    <p class="document-type">{{ 'LEGAL_DOCUMENT_' + documentType() | translate }}</p>
  }

  @if (documentUrl(); as url) {
    <iframe class="document-frame" [attr.src]="url" [title]="'SIGN_LEGAL_DOCUMENT_MODAL_TITLE' | translate"></iframe>
  } @else {
    <app-loader [visible]="true" [fullPage]="false" />
  }
</app-modal>
